export class FiltreItem {
  field: string;
  value: any;
  displayName: string;

  constructor(field: string, displayName: string, value: any) {
    this.field = field;
    this.displayName = displayName;
    this.value = value;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/pages/cerba/pages/catalogue-examens/filtres/vos-filtres/filtre-item.ts